/* eslint-disable */
import {
  FINISH_POKA_CHECKLIST_FAIL,
  FINISH_POKA_CHECKLIST_START,
  FINISH_POKA_CHECKLIST_SUCCESS,
  GET_POKA_CHECKLIST_START,
  GET_POKA_CHECKLIST_SUCCESS,
} from './constants';

const initialState = {
  isLoading: false,
  checkListInfo: null,
};

export default (state = initialState, { type, response, value }) => {
  switch (type) {
    case GET_POKA_CHECKLIST_START:
      return { ...state, isLoading: true, checkListInfo: null };

    case GET_POKA_CHECKLIST_SUCCESS:
      return { ...state, isLoading: false, checkListInfo: response };

    case FINISH_POKA_CHECKLIST_START:
      return { ...state, isLoading: true };

    case FINISH_POKA_CHECKLIST_SUCCESS:
    case FINISH_POKA_CHECKLIST_FAIL:
      return { ...state, isLoading: false };

    default:
      return { ...state };
  }
};
